export const search = {
  brand: 'Search results',
  treasures: 'Our treasures',
  noProducts: 'No products match your criteria.',
  resultsFor: 'Search results for \"{searchString}\"',
  caption: {
    categories: 'Categories',
    query: 'Query',
  },
  scope: {
    format: 'Search in {scope}',
    everywhere: 'all products',
  },
  filter: {
    reset: 'Reset all filters',
    toggleDetails: 'Filters',
    offerPrice: 'Offers only',
    price: 'Price',
    priceRange: 'Price range',
    properties: 'Properties',
    property: {
      new: 'New',
      tiefgekuehlt: 'Frozen',
      gekuehlt: 'Chilled',
      wiegeartikel: 'Weighed product',
      bestellartikel: 'Pre-order product',
      bio: 'Organic',
      msc: 'MSC',
      asc: 'ASC',
      unsere_kostbarkeiten: 'Our treasures',
      dauertiefpreis: 'Low price',
    },
  },
  emptyResult: 'No products found.',
  pagination: {
    currentProgress: '{current} of {total}',
    showMore: 'Show more',
    backToTop: 'Back to top',
  },
  suggestions: {
    items: 'Articles',
    close: 'Close search',
    moreMulti: '{moreProducts} more Articles',
    moreSingle: '{moreProducts} more Article',
  },
};

export const myProducts = {
  brand: 'My products',
  logoCharacter: 'm',
};

export const browse = {
  brand: 'Assortment',
  showAll: 'Show all products',
  categoryFilter: {
    back: 'Back',
  },
  overpack: 'Overpack',
};

export const detail = {
  back: 'Back',
  badges: {
    new: 'NEW',
    offer: 'OFFER',
    lowPrice: 'LOW PRICE',
  },
  noSuchProduct: 'This product could not be found.',
  attributes: {
    productSku: 'Item number',
    netFillQuantity: 'Net filling quantity',
    basePrice: 'Base price',
    description: 'Product description',
    ingredients: 'Ingredients',
    alcohol: 'Alcohol',
    contact: 'Contact information',
    // These attributes are intentionally not written in camelCase, since the attributes are stored with a dash '-'.
    // For easier key matching, we just remove the dash "storage-note" -> "storagenote"
    storagenote: 'Storage note',
    preparationnote: 'Preparation note',
    winegrower: 'Wine grower',
    wineregion: 'Wine region',
  },
  links: {
    overview: 'Overview',
    description: 'Product description',
    nutrient: 'Nutrients',
    ingredients: 'Ingredients, Storage notes, Allergens',
    producer: 'Producer',
  },
  nutrition: {
    title: 'Nutrition',
    header: {
      serving: 'Per Serving',
      oneHundred: 'Per 100g',
      prepared: 'prepared',
      unPrepared: 'unprepared',
      amount: 'Amount',
      intake: '% Intake*',
    },
    labels: {
      energy: 'Energy',
      fat: 'Fat',
      choavl: 'Carbohydrates',
      fibtg: 'Dietary fibres',
      pro: 'Proteines',
      salteq: 'Salt',
      fasat: 'of which saturated',
      famscis: 'of which monounsaturated',
      fapucis: 'of which polyunsatured',
      polyl: 'of which multiple alcohols',
      starch: 'of which starch',
      sugar: 'of which sugar',
    },
    referenceIntakeInfo: '* Reference value of an average adult (8.400 kJ / 2.000 kcal)',
  },
  allergens: {
    title: 'Allergens',
    contained: 'Contained Allergens',
    traces: 'Allergen Traces',
    keys: {
      a: 'Grains containing gluten and products thereof',
      b: 'Crustaceans and products thereof',
      c: 'Eggs and products thereof',
      d: 'Fish and products thereof',
      e: 'Peanuts and products thereof',
      f: 'Soy and products thereof',
      g: 'Milk or lactose and products thereof',
      h: 'Edible nuts and products thereof',
      l: 'Celery and products thereof',
      m: 'Mustard and products thereof',
      n: 'Sesame and products thereof',
      o: 'Sulphur dioxide and sulphites',
      p: 'Lupin and products thereof',
      r: 'Molluscs and products thereof',
    },
  },
};
